import React from "react";
import { Row, Col, Icon } from "antd";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { withRouter } from "react-router";
import { StepStatus } from "../types/enums";
import globalColors from "../styles/globalColors";

export type ProgressStepType = {
  icon: string;
  title: string;
  status: StepStatus;
  route: string;
};

const statusColor = (status: StepStatus) => {
  if (status === StepStatus.PENDING) {
    return "#ccc";
  } else if (status === StepStatus.ACTIVE) {
    return globalColors.secondary;
  } else {
    return globalColors.green;
  }
};

const Progress = (props: { steps: ProgressStepType[]; history?: any }) => {
  const { steps } = props;

  return (
    <Row type="flex" gutter={16} style={{ marginBottom: 40 }}>
      {steps.map(step => {
        const stepComplete = step.status === "complete";
        return (
          <Col
            key={step.title}
            css={{
              width: `${100 / steps.length}%`,
              cursor: stepComplete ? "pointer" : "default"
            }}
            onClick={() => {
              if (stepComplete) {
                props.history.push(step.route);
              }
            }}
          >
            <div
              style={{
                height: 15,
                backgroundColor: statusColor(step.status),
                marginBottom: 5
              }}
            />
            <div
              style={{
                color: statusColor(step.status),
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start"
              }}
            >
              <div>
                <Icon
                  type={stepComplete ? "check-circle" : step.icon}
                  theme="filled"
                />
              </div>
              <div style={{ paddingLeft: 5 }}>{step.title}</div>
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

// @ts-ignore
export default withRouter(Progress);
